import { useLocation } from 'react-router-dom';

import { ShellSkeleton } from '@/components/admin/shell-skeleton';
import { Spinner } from '@/components/ui/spinner';
import { env, HOST_PAINTS_LOADER } from '@/lib/env';
import { isVisitorRoute } from '@/lib/kit-scope';

// Same size and colour as the public viewer's own loading spinner: the tour
// route's lazy chunk shows this first and then that one, so they must read
// as a single spinner that simply keeps turning. Visitor routes only (/t, /o,
// the embed): the visitor look is not the tool's and stays dark whatever theme
// the person picked in the panel.
function VisitorLoader() {
  return (
    // eslint-disable-next-line no-restricted-syntax -- matches the visitor's loading screen, not tool UI
    <div data-slot="route-loader" data-zone="visitor" className="flex h-screen items-center justify-center bg-neutral-950 text-white">
      {HOST_PAINTS_LOADER ? null : <Spinner size="lg" />}
    </div>
  );
}

/** Tool routes without a shell (login, signup, connect…): the canvas of the chosen theme and a spinner. */
function ToolLoader() {
  return (
    <div data-slot="route-loader" data-zone="tool" className="flex h-screen items-center justify-center bg-canvas text-ink-3">
      <Spinner size="lg" />
    </div>
  );
}

/**
 * What shows while a route's chunk downloads or the session hydrates. By zone:
 * visitor routes keep the dark loader that matches the viewer's own spinner;
 * `/admin` shows the shell's skeleton (so the first paint is already the
 * panel's layout); the other tool routes get the themed canvas and a spinner.
 */
export function RouteLoader() {
  const { pathname } = useLocation();
  if (isVisitorRoute(pathname, env.IS_EMBED_MODE)) return <VisitorLoader />;
  if (pathname === '/admin' || pathname.startsWith('/admin/')) return <ShellSkeleton pathname={pathname} />;
  return <ToolLoader />;
}
